import { SANS_3, UI_BODY_SM_DF } from 'oolib'
import React from 'react'

export default function TableArrayCount({value}) {
  return (
    <UI_BODY_SM_DF>{value?value.length:0} </UI_BODY_SM_DF>
  )
}
